import React from "react";
import { withStyles } from "@material-ui/core";
import { getApprovalRequests } from "relay/main";
import { styles } from "./style";
import { getAppPath } from "constants/path";
import UserContext from "context/UserContext";
import { useParams } from "react-router-dom";
import TabBar from "storybookComponents/TabBar";
import MyApprovals from "./MyApprovals";
import AllApprovals from "./AllApprovals";
import ApprovalHistory from "./ApprovalHistory";
import { FilterIcon } from "icons";
import clsx from "clsx";

const tabs = ["My Approvals", "All Approvals", "Approval History"];
const agentTabs = ["My Requests", "Request History"];

const steps = {
  0: "my-approval",
  1: "all-approval",
  2: "approval-history",
};

const screens = {
  0: "myApprovals",
  1: "allApprovals",
  2: "approvalHistory",
};

const agentScreens = {
  0: "myRequests",
  1: "requestHistory",
};

const Approvals = withStyles(styles)(
  ({
    classes,
    setTitle,
    isAllTabsAccess,
    orgLevel,
    setOriginNavItems,
    history,
    isNotificationsBarVisible,
    ...rest
  }) => {
    const { subOrgDetails } = React.useContext(UserContext);
    const [isLoading, setIsLoading] = React.useState(false);
    const [approvals, setApprovals] = React.useState([]);
    const [tabIndex, setTabIndex] = React.useState(0);
    const [type, setType] = React.useState(0);
    const [showFilter, setShowFilter] = React.useState(false);

    const { step } = useParams();

    const handleTabChange = (index) => {
      setTabIndex(index);
      if (!isAllTabsAccess && index != 0) {
        history.push(getAppPath() + "/approvals/" + steps[2]);
        return;
      }
      history.push(getAppPath() + "/approvals/" + steps[index]);
    };

    const setIndexValue = () => {
      let url = step ? step : "my-approval";
      let index = url === "my-approval" ? 0 : url === "all-approval" ? 1 : 2;
      if (!isAllTabsAccess && index != 0) {
        index = 1;
      }
      console.log("step", step);
      setTabIndex(index);
      getTypesValues(index);
    };

    const getApprovals = async (type) => {
      if (subOrgDetails.org.id) {
        try {
          setIsLoading(true);
          const response = await getApprovalRequests(
            subOrgDetails.org.id,
            type,
            subOrgDetails.id
          );
          if (response.approvalRequests) {
            let data = response.approvalRequests.edges.map((ele) => {
              return {
                ...ele.node.hyevent,
                propertyId: ele.node.propertyId,
                approvedAt: ele.node.approvedAt,
                approverEmails: ele.node.approverEmails,
                propertyName: ele.node.propertyName,
                createdAt: ele.node.createdAt,
              };
            });
            setApprovals(data);
          }
          setIsLoading(false);
        } catch (error) {
          console.error(error);
        }
      }
    };

    React.useEffect(() => {
      setIndexValue();
    }, [step]);

    // set the header bar title
    React.useEffect(() => {
      setTitle("Approvals");
      setOriginNavItems(orgLevel);
    }, []);

    const getTypesValues = (index) => {
      let value;
      if (isAllTabsAccess) {
        value = screens[index];
      } else {
        value = agentScreens[index];
      }
      setType(value);
      getDataForPages(value);
    };

    const getDataForPages = (value) => {
      switch (value) {
        case "myApprovals":
          getApprovals("hyevents_my_approvals");
          break;
        case "allApprovals":
          getApprovals("hyevents_all_approvals");
          break;
        case "myRequests":
          getApprovals("hyevents_my_request");
          break;
        case "approvalHistory":
          getApprovals("hyevents_approval_history");
          break;
        case "requestHistory":
          getApprovals("hyevents_request_history");
          break;
        default:
          break;
      }
    };

    const renderContent = () => {
      if (!isAllTabsAccess) {
        switch (tabIndex) {
          case 0:
            return (
              <MyApprovals
                showFilter={showFilter}
                isAllTabsAccess={isAllTabsAccess}
                {...rest}
                history={history}
                classes={classes}
                isLoading={isLoading}
                data={approvals}
              />
            );
          case 1:
            return (
              <ApprovalHistory
                showFilter={showFilter}
                isAllTabsAccess={isAllTabsAccess}
                {...rest}
                history={history}
                classes={classes}
                isLoading={isLoading}
                data={approvals}
              />
            );
        }
      } else {
        switch (tabIndex) {
          case 0:
            return (
              <MyApprovals
                showFilter={showFilter}
                isAllTabsAccess={isAllTabsAccess}
                {...rest}
                history={history}
                classes={classes}
                isLoading={isLoading}
                data={approvals}
              />
            );
          case 1:
            return (
              <AllApprovals
                showFilter={showFilter}
                isAllTabsAccess={isAllTabsAccess}
                {...rest}
                history={history}
                classes={classes}
                isLoading={isLoading}
                data={approvals}
              />
            );
          case 2:
            return (
              <ApprovalHistory
                showFilter={showFilter}
                isAllTabsAccess={isAllTabsAccess}
                {...rest}
                history={history}
                classes={classes}
                isLoading={isLoading}
                data={approvals}
              />
            );
        }
      }
    };

    return (
      <div className={`${classes.root} ${isNotificationsBarVisible && classes.customRoot}`}>
        <div className={classes.headerBar}>
          <TabBar
            tabs={isAllTabsAccess ? tabs : agentTabs}
            onChange={handleTabChange}
            index={tabIndex}
          />
          <div
            className={
              showFilter ? clsx(classes.iconWrapper, classes.activeWrapper) : classes.iconWrapper
            }
            onClick={() => setShowFilter(!showFilter)}
          >
            <FilterIcon className={classes.filterIcon} />
          </div>
        </div>
        {renderContent()}
      </div>
    );
  }
);

export default Approvals;
